module.exports = __webpack_public_path__ + "img/carteria.c4bcf3d3.png";